import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Paper from '@mui/material/Paper';
import { PanelHeader } from '../../../../panels/panelHeader';
import { PanelContainer } from '../../../../panels/panelStyles';
import { SIDE_BETS_PANEL_LIST_BACKGROUND_COLOR } from '../../../../styles/colors';
import { PANEL_CONTENT_PADDING_STRING } from '../../../../styles/styles';
import { SelectSideBetButtonContainer } from './selectSideBetButtonContainer';
import { SideBetItemsContainer } from './sideBetItemsContainer';
import { SideBetPotPanelItemContainer } from './sideBetPotPanelItemContainer';
const PAPER_CSS = css `
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: ${SIDE_BETS_PANEL_LIST_BACKGROUND_COLOR} !important;
  padding: 0;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const SideBetsPanel = () => {
    return (_jsxs(PanelContainer, { padding: PANEL_CONTENT_PADDING_STRING, "aria-label": 'side bets panel', children: [_jsx(PanelHeader, { title: 'Side Bets', color: 'white', gameGuidePageType: 'side-bets' }), _jsxs(Paper, { component: 'section', css: PAPER_CSS, children: [_jsx(SelectSideBetButtonContainer, {}), _jsx(SideBetItemsContainer, {})] }), _jsx(SideBetPotPanelItemContainer, {})] }));
};
